import type { ReviewImageView } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { useModalDialog } from '@/shared/lib';
import { Button, DialogFrame } from '@/shared/ui';

interface ReviewImageViewerProps {
  readonly images: readonly ReviewImageView[];
  readonly index: number;
  readonly onChangeIndex: (index: number) => void;
  readonly onClose: () => void;
}

/** 후기 사진 크게 보기 — 열려 있는 동안만 그려진다(모달 훅이 마운트 때 연다). */
export const ReviewImageViewer = ({
  images,
  index,
  onChangeIndex,
  onClose,
}: ReviewImageViewerProps): ReactElement | null => {
  const modal = useModalDialog(onClose, true);
  const image = images[index];
  if (image === undefined) return null;
  return (
    <DialogFrame
      modal={modal}
      title="후기 사진"
      className="max-w-3xl"
      bodyClassName="flex justify-center"
      footer={
        <>
          {images.length > 1 && (
            <>
              <Button
                variant="outline"
                size="sm"
                disabled={index === 0}
                onClick={() => onChangeIndex(index - 1)}
              >
                이전 사진
              </Button>
              <span className="self-center text-sm text-muted-foreground tabular-nums">
                {index + 1} / {images.length}
              </span>
              <Button
                variant="outline"
                size="sm"
                disabled={index === images.length - 1}
                onClick={() => onChangeIndex(index + 1)}
              >
                다음 사진
              </Button>
            </>
          )}
          <Button size="sm" onClick={onClose}>
            닫기
          </Button>
        </>
      }
    >
      <img src={image.url} alt={`후기 사진 ${index + 1}`} className="max-h-[60dvh] w-auto" />
    </DialogFrame>
  );
};
